module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_apply main_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "重新提交申请",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "dataInfo",
    staticClass: "demo-ruleForm myForm",
    staticStyle: {
      "width": "70%",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.dataInfo,
      "rules": _vm.rulesData,
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "item_box"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("申请人基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "inpitem_box"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.RequesterName.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    staticStyle: {
      "left": "30px"
    },
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请人姓名:",
      "prop": "RequesterName.NodeValue"
    }
  }, [_c('el-input', {
    staticClass: "inpItem",
    attrs: {
      "disabled": _vm.dataInfo.RequesterName.disabled
    },
    model: {
      value: (_vm.dataInfo.RequesterName.NodeValue),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo.RequesterName, "NodeValue", $$v)
      },
      expression: "dataInfo.RequesterName.NodeValue"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inpitem_box"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.RequesterPhoneNum.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    staticStyle: {
      "left": "30px"
    },
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请人电话:",
      "prop": "RequesterPhoneNum.NodeValue"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.dataInfo.RequesterPhoneNum.NodeValue),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo.RequesterPhoneNum, "NodeValue", $$v)
      },
      expression: "dataInfo.RequesterPhoneNum.NodeValue"
    }
  })], 1)], 1), _vm._v(" "), (_vm.commitType == 2) ? _c('div', {
    staticClass: "inpitem_box"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.RequesterOrganisation.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    staticStyle: {
      "left": "44px"
    },
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在单位:",
      "prop": "RequesterOrganisation.NodeValue"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.dataInfo.RequesterOrganisation.disabled
    },
    model: {
      value: (_vm.dataInfo.RequesterOrganisation.NodeValue),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo.RequesterOrganisation, "NodeValue", $$v)
      },
      expression: "dataInfo.RequesterOrganisation.NodeValue"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.commitType == 2) ? _c('div', {
    staticClass: "inpitem_box"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.PersonIdentification.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    staticStyle: {
      "left": "15px"
    },
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "个人身份证明:",
      "prop": "PersonIdentification.NodeValue"
    }
  }, [(_vm.dataInfo.PersonIdentification.CheckStatus != 0) ? _c('div', _vm._l((_vm.dataInfo.PersonIdentification.NodeValue), function(item) {
    return _c('div', {
      key: item.FileGuid,
      staticClass: "input_box"
    }, [_c('div', {
      ref: 'indexImg_' + item.FileGuid,
      refInFor: true,
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "id": 'indexImg_' + item.FileGuid
      }
    }, [_c('ul', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('li', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('span', {
      staticClass: "input_fileName",
      staticStyle: {
        "display": "inline-block",
        "color": "#606266"
      }
    }, [_vm._v("\n                                                " + _vm._s(item.FileName) + "\n                                            ")]), _vm._v(" "), _c('a', {
      staticClass: "view_a",
      attrs: {
        "target": "_blank",
        "id": "test"
      },
      on: {
        "click": function($event) {
          return _vm.showImgFn(item.FileGuid)
        }
      }
    }, [_vm._v("\n                                                查看\n                                                "), _c('img', {
      attrs: {
        "xss": "removed",
        "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid
      }
    })])])]), _vm._v(" "), _c('a', {
      staticClass: "download_a",
      attrs: {
        "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid,
        "download": "个人身份证明",
        "title": "下载",
        "target": "_blank"
      }
    }, [_vm._v("\n                                        下载\n                                    ")])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.dataInfo.PersonIdentification.CheckStatus == 0) ? _c('div', [_vm._l((_vm.dataInfo.PersonIdentification.NodeValue), function(item) {
    return _c('div', {
      key: item.FileGuid,
      staticClass: "input_box"
    }, [(_vm.ifFileNmae0) ? _c('div', {
      ref: 'indexImg_' + item.FileGuid,
      refInFor: true,
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "id": 'indexImg_' + item.FileGuid
      }
    }, [_c('ul', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('li', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [(_vm.ifFileNmae0) ? _c('span', {
      staticClass: "input_fileName",
      staticStyle: {
        "display": "inline-block",
        "color": "#606266"
      }
    }, [_vm._v("\n                                                " + _vm._s(item.FileName) + "\n                                            ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "view_a",
      attrs: {
        "target": "_blank",
        "id": "test"
      },
      on: {
        "click": function($event) {
          return _vm.showImgFn(item.FileGuid)
        }
      }
    }, [_vm._v("\n                                                查看\n                                                "), _c('img', {
      attrs: {
        "xss": "removed",
        "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid
      }
    })])])]), _vm._v(" "), _c('a', {
      staticClass: "download_a",
      attrs: {
        "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid,
        "download": "个人身份证明",
        "title": "下载",
        "target": "_blank"
      }
    }, [_vm._v("\n                                        下载\n                                    ")])]) : _vm._e()])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth(0)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-img": _vm.url,
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.$imgPreview
    }
  }, [_vm._v("模板")]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("个人身份证明为作者本人身份证扫描件、学生证扫描件或者教师证扫描件，支持gif、png、jpg格式"), _c('br'), _vm._v("请一次性上传所有文件")])], 2) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item_box"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("待撤文章信息")]), _vm._v(" "), _c('div', {
    staticClass: "inpitem_box"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.ArticleName.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    staticStyle: {
      "left": "45px"
    },
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "题目名称:",
      "prop": "ArticleName.NodeValue"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.dataInfo.ArticleName.disabled
    },
    model: {
      value: (_vm.dataInfo.ArticleName.NodeValue),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo.ArticleName, "NodeValue", $$v)
      },
      expression: "dataInfo.ArticleName.NodeValue"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inpitem_box"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.Author.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    staticStyle: {
      "left": "75px"
    },
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作者:",
      "prop": "Author.NodeValue"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.dataInfo.Author.disabled
    },
    model: {
      value: (_vm.dataInfo.Author.NodeValue),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo.Author, "NodeValue", $$v)
      },
      expression: "dataInfo.Author.NodeValue"
    }
  })], 1)], 1), _vm._v(" "), (_vm.commitType == 2) ? _c('div', {
    staticClass: "inpitem_box"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.UnitIdentification.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    staticStyle: {
      "left": "-10px"
    },
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位允许撤除证明:",
      "prop": "UnitIdentification.NodeValue"
    }
  }, [(_vm.dataInfo.UnitIdentification.CheckStatus != 0) ? _c('div', [_c('div', {
    ref: 'indexImg_' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v(_vm._s(_vm.dataInfo.UnitIdentification.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid,
      "download": "单位允许撤除证明",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                                    下载\n                                ")])])]) : _vm._e(), _vm._v(" "), (_vm.dataInfo.UnitIdentification.CheckStatus == 0) ? _c('div', [(_vm.ifFileNmae1) ? _c('div', {
    ref: 'indexImg_' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v(_vm._s(_vm.dataInfo.UnitIdentification.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.UnitIdentification.NodeValue[0].FileGuid,
      "download": "单位允许撤除证明",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                                    下载\n                                ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth(1)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('span', {
    staticClass: "model_span",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetTemplateFile',
      "download": "单位允许撤除证明模板",
      "title": "单位允许撤除证明模板",
      "target": "_blank"
    }
  }, [_vm._v("\n                                    模板\n                                ")])]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("证明必须加盖检测单位管理部门公章，支持gif、png、jpg格式")])], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inpitem_box"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.CheckReport.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    staticStyle: {
      "left": "30px"
    },
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检测报告单:",
      "prop": "CheckReport.NodeValue",
      "required": ""
    }
  }, [(_vm.dataInfo.CheckReport.CheckStatus != 0) ? _c('div', [_c('div', {
    ref: 'indexImg_' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v(_vm._s(_vm.dataInfo.CheckReport.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.CheckReport.NodeValue[0].FileGuid, 'pdf')
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid,
      "download": "检测报告单",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                                    下载\n                                ")])])]) : _vm._e(), _vm._v(" "), (_vm.dataInfo.CheckReport.CheckStatus == 0) ? _c('div', [(_vm.ifFileNmae2) ? _c('div', {
    ref: 'indexImg_' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v(_vm._s(_vm.dataInfo.CheckReport.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.CheckReport.NodeValue[0].FileGuid, 'pdf')
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.CheckReport.NodeValue[0].FileGuid,
      "download": "检测报告单",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                                    下载\n                                ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth(2)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-img": _vm.url2,
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.$imgPreview
    }
  }, [_vm._v("示例")]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("请提供最近一次检测报告单，并在报告单上标注要撤除的文献，支持pdf格式")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "inpitem_box"
  }, [_c('img', {
    staticClass: "warn_icon",
    class: _vm.dataInfo.ArticleLocation.CheckStatus == 0 ? 'showIcon' : 'hideIcon',
    staticStyle: {
      "left": "20px"
    },
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "待撤文章位置:",
      "prop": "ArticleLocation.NodeValue",
      "required": ""
    }
  }, [(_vm.dataInfo.ArticleLocation.CheckStatus != 0) ? _c('div', [_c('div', {
    ref: 'indexImg_' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v(_vm._s(_vm.dataInfo.ArticleLocation.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid,
      "download": "待撤文章位置",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                                    下载\n                                ")])])]) : _vm._e(), _vm._v(" "), (_vm.dataInfo.ArticleLocation.CheckStatus == 0) ? _c('div', [(_vm.ifFileNmae3) ? _c('div', {
    ref: 'indexImg_' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v(_vm._s(_vm.dataInfo.ArticleLocation.NodeValue[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.dataInfo.ArticleLocation.NodeValue[0].FileGuid,
      "download": "待撤文章位置",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                                    下载\n                                ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth(3)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-img": _vm.url2,
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.$imgPreview
    }
  }, [_vm._v("示例")]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("请将待撤文章在检测报告单中的具体位置进行标注并上传标注后的附件，支持gif、png、jpg格式")])], 1) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "subBtn_box"
  }, [_c('el-form-item', {
    staticClass: "btn_box"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.regLoading),
      expression: "regLoading"
    }],
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitInfo('dataInfo')
      }
    }
  }, [_vm._v("确认提交")]), _vm._v(" "), _c('el-button', {
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backViewPageFn
    }
  }, [_vm._v("取消")])], 1)], 1)]), _vm._v(" "), _c('global-uploader')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7188191e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userPages/applyRecord/reApplyPage.vue
// module id = 1193
// module chunks = 1